import React from 'react';
import { styleBreakDesktop } from '../utilities/layouts/Globals';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ChatPage from './ChatPage';
import { Redirect } from 'react-router-dom';
import { PATH_HOME, PATH_CHAT } from '../../containers/RoutePaths';
import useTheme from '@material-ui/core/styles/useTheme';

export const ChatPageRedirectWrapper = () => {
    const theme = useTheme();
    // use the useMediaQuery noSsr option to prevent rendering twice since we do not use server side rendering
    const desktop = useMediaQuery(styleBreakDesktop(theme), { noSsr: true });
    return desktop ? <Redirect from={PATH_CHAT} to={PATH_HOME} /> : <ChatPage />;
};
